<template>
    <div
        class="annotation-card-container"
        tabindex="0"
    >
        <div class="annotation-info">
            <div class="annotation-title">
                <div style="flex: 1">
                    <h1>{{ data.digitalObjects[0].label ?? data.digitalObjects[0].uri }}</h1>
                </div>
            </div>
            <div class="icon-container">
                <span v-if="datasetIcon != ''" class="attribution-container">
                    <span class="legend-icon">{{ datasetIcon }}</span>
                    <span style="padding-right: 26px;"></span>
                </span>
                <span class="truncate-text">{{ data.typeLabel ?? data.type }}</span>
            </div>
            <p class="quote-container" v-if="data.quote">{{ data.quote }}</p>
        </div>
        <div class="annotation-button-container">
            <button
                class="annotation-button button-left"
                v-on:click="openTarget"
                v-on:keydown.enter="openTarget"
            >
                Go to mention
                <img
                    class="img-fluid"
                    src="@/assets/external-link-line.svg"
                    alt="External link"
                />
            </button>
            <button
                class="annotation-button button-right"
                v-on:click="selectAnnotation"
                v-on:keydown.enter="selectAnnotation"
            >
                Details
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";

@Options({
    props: {
        index: Number,
        data: Object,
        datasetLabel: String,
    },
})
export default class AnnotationCard extends Vue {
    index!: number;
    data!: any;
    datasetLabel!: string;

    selectAnnotation() {
        this.$emit('update', { index: this.index })
    }

    openTarget() {
        (window as any).open(this.getWebReferenceTarget(this.data), '_blank').focus();
    }

    // Parse an annotation and return the target
    getWebReferenceTarget(annotation: any) {
        if (annotation?.digitalObjects?.length == 0) {
            return "";
        } else {
            return annotation?.digitalObjects[0]?.uri ?? '';
        }
    }

    get datasetIcon(): string {
        return this.datasetLabel.slice(0, 2).toUpperCase();
    }
}
</script>
<style>
.annotation-info {
    padding: 8px 12px;
}
.annotation-info h1 {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    margin: 0px;
    padding-bottom: 2px;
}
.annotation-info p,
.annotation-info a {
    display: block;
    color: #5e6364;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 0px;
    width: 100%;
    overflow: hidden;
}
.annotation-title {
    display: flex;
    justify-content: center;
    align-items: center;
}
.annotation-img-container {
    overflow: hidden;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 5px;
}
.annotation-img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}
.attribution-container {
    vertical-align: middle;
}
.icon-container {
    display: flex;
    gap: 2px;
}
.legend-icon {
    position: absolute;
    padding: 5px;
    margin-right: 5px;
    color: white;
    background-color: #107386;
    font-size: 10px !important;
    border-radius: 50%;
}
.quote-container {
    display: -webkit-box !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* Truncate after 3 lines */
    overflow: hidden;
}
.annotation-button-container {
    display: flex;
    width: 100%;
}
.annotation-button {
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    background-color: unset;
    color: #083943;
    font-weight: bold;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    transition: 0.3s all ease;
}
.annotation-button:hover,
.annotation-button.active {
    background-color: #edf6f8;
    transition: 0.3s all ease;
}
.annotation-button.button-left {
    border-right: 0.5px solid #ccc;
}
.annotation-button.button-right {
    border-left: 0.5px solid #ccc;
}
</style>
